// src/pages/Financas/GastoForm.js
import React, { useState } from 'react';
import './GastoForm.css';

const GastoForm = ({ onAdicionarGasto }) => {
  const [descricao, setDescricao] = useState('');
  const [valor, setValor] = useState('');
  const [data, setData] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!descricao || !valor || !data) {
      alert('Por favor, preencha todos os campos.');
      return;
    }
    if (parseFloat(valor) <= 0) {
        alert('O valor do gasto deve ser maior que zero.');
        return;
    }

    onAdicionarGasto({
      descricao,
      valor: parseFloat(valor),
      data: new Date(data), // Converte a string de data para um objeto Date
    });

    // Limpa o formulário
    setDescricao('');
    setValor('');
    setData('');
  };

  return (
    <form onSubmit={handleSubmit} className="gasto-form">
      <h3>Registrar Novo Gasto</h3>
      <div className="form-group">
        <label>Descrição:</label>
        <input
          type="text"
          value={descricao}
          onChange={(e) => setDescricao(e.target.value)}
          placeholder="Ex: Compra de ingredientes, Aluguel"
          required
        />
      </div>
      <div className="form-group">
        <label>Valor (R$):</label>
        <input
          type="number"
          step="0.01"
          value={valor}
          onChange={(e) => setValor(e.target.value)}
          placeholder="0.00"
          required
        />
      </div>
      <div className="form-group">
        <label>Data:</label>
        <input
          type="date"
          value={data}
          onChange={(e) => setData(e.target.value)}
          required
        />
      </div>
      <button type="submit" className="adicionar-gasto-btn">Adicionar Gasto</button>
    </form>
  );
};

export default GastoForm;